var _line, _line2, _line3, _line4, _line5, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNowPlaying(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 1,
    x2: 13,
    y2: 23,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 7,
    y2: 20,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 19,
    y2: 20,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 8,
    x2: 1,
    y2: 18,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 8,
    x2: 25,
    y2: 18,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 9L36.8038 15L47.1962 15L42 9Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowPlaying);
export default __webpack_public_path__ + "static/media/NowPlaying.550deff1ff4e01a24db2fd66f65f340a.svg";
export { ForwardRef as ReactComponent };